import * as actionTypes from '../constants/action-types';

const initialState = {
    isRequesting: false,
    incidentTypes: [],
    list: [{
        policy_id: null,
        farm_uuid: null,
        entity_uuid: null,
        entity_name: null,
        entity_type_id: null,
        entity_type_name: null,
        phones: [],
        policy_config: {
            load_approve_stop: 0,
            resumed_harvester: 0,
            waiting_harvester: 0,
            resumed_load_approve: 0
        }
    }],
    egOperators: [],
    userList: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_POLICY_REQUEST: {
            state = { ...state, isRequesting: true, list: [] };
            break;
        } 

        case actionTypes.GET_INCIDENT_TYPE: {
            const payload = action.payload ? action.payload : initialState.incidentTypes;
            state = { ...state, incidentTypes: payload };
            break;
        }

        case actionTypes.GET_POLICY_LIST: {
            const payload = action.payload ? action.payload : initialState.list;
            state = { ...state, isRequesting: false, list: payload };
            break;
        }

        case actionTypes.GET_EG_OPERATOR: {
            const payload = action.payload ? action.payload : initialState.egOperators;
            state = { ...state, egOperators: payload };
            break;
        }

        case actionTypes.GET_FARM_USERS: {
            const payload = action.payload ? action.payload : initialState.userList;
            state = { ...state, userList: payload };
            break;
        }

        default:
            break;
    }
    return state;
};